import { memo } from 'react'

export type SkeletonShape =
  | 'input'
  | 'textarea'
  | 'checkbox'
  | 'button'
  | 'upload'
  | 'text'
  | 'audio'
  | 'heading'
  | 'table'

interface SkeletonProps {
  shape: SkeletonShape
  className?: string
}

// A pulsing placeholder with the size and corners of the component it stands in for
export const Skeleton = memo(({ shape, className }: SkeletonProps) => (
  <span
    className={['skeleton', `skeleton--${shape}`, className ?? ''].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
))

Skeleton.displayName = 'Skeleton'
